import type { ProjectGraphIpcAncestor, ProjectGraphNode } from '@avisoma/shared';

type IpcNode = Extract<ProjectGraphNode, { kind: 'ipc' }>;

/**
 * DR-5084: one assembly above an IPC position: its item, then its distinct nomenclatures (the catalogue's alternates)
 * joined by " / " ("item 1 · CASE ASSY"); just the item when no entry names it.
 */
export function ancestorLabel(ancestor: ProjectGraphIpcAncestor): string {
  const names = [...new Set(ancestor.entries.map((entry) => entry.nomenclature.trim()).filter((name) => name !== ''))];
  return names.length === 0 ? `item ${ancestor.item}` : `item ${ancestor.item} · ${names.join(' / ')}`;
}

/** DR-5084: the position's assemblies, top of the figure first (`ancestorLabel`); `[]` when not computed or at the top. */
export function ipcAncestorLines(node: IpcNode): string[] {
  return (node.ancestors ?? []).map(ancestorLabel);
}
